import { action } from 'satcheljs';

// Action to dispatch for orchestrator use in owa-layout
// Importantly needed to avoid a circular dependency between:
// - owa-layout: Needing copilot chat drawer store for width of pane
// - owa-copilot-chat-drawer-store: Needing owa-layout for layout change handling
export const onCopilotChatDrawerLayoutChange: () => {} = action('onCopilotChatDrawerLayoutChange');
